import axios, { baseUrl, pobClientId, pobApiKey } from './axios';
import queryString from 'query-string';

export default {
  login: async options => {
    const result = await axios.post(
      `${baseUrl}/account/pub/pob/patient/logins`,
      { ...options.data, clientId: Number(pobClientId) },
    );
    return result.data;
  },
  loginAnonymous: async () => {
    const result = await axios.post(`${baseUrl}/account/pub/tokens`, {
      apiKey: pobApiKey,
      clientId: Number(pobClientId),
    });
    return result.data;
  },
  recoveryPassword: async options => {
    const params = queryString.stringify(options.data);
    const result = await axios.get(
      `${baseUrl}/account/pob/patient/verify_codes${
        params ? `?${params}` : ''
      }`,
    );
    return result.data;
  },
  confirmVerifyCodeChangePassword: async options => {
    const result = await axios.post(
      `${baseUrl}/account/pob/patient/verify_codes`,
      options.data,
    );
    return result.data;
  },

  changePassword: async options => {
    const result = await axios.post(
      `${baseUrl}/account/pob/patients/${options.patientId.toString()}/change_passwords`,
      options.data,
    );
    return result.data;
  },

  getPatientInformation: async options => {
    const result = await axios.get(
      `${baseUrl}/customer/pob/patient/${options.data.patientId.toString()}/next_of_kins`,
    );
    return result.data;
  },
};
